export const responseTypes = {
    STATUS_UPDATED: {
        status: 'STATUS_UPDATED',
        message: 'Status has been changed successfully'
    }
}
